export default "__VITE_PUBLIC_ASSET__fb535c0c__"